// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"X3-z"};